import React, { Fragment } from "react";

import img13 from "../../../images/service/Smart Contract Audit Services/1.png";
import img14 from "../../../images/service/Smart Contract Audit Services/2.png";
import img15 from "../../../images/service/Smart Contract Audit Services/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Manual Code Review",
    content:
      "In-depth line-by-line analysis to identify logic flaws, vulnerabilities, and inefficient code patterns.",
  },
  {
    icon: sIcon2,
    title: "Automated Security Testing",
    content:
      "Advanced tools detect known vulnerabilities, exploits, and security loopholes.",
  },
  {
    icon: sIcon3,
    title: "Gas Optimization Review",
    content:
      "Optimize smart contract performance to reduce gas costs and improve execution efficiency.",
  },
];

const benefits = [
  {
    title: "Enhanced Security",
    description:
      "Identify and eliminate vulnerabilities before deployment to prevent exploits.",
    icon: sIcon1,
  },
  {
    title: "Investor Confidence",
    description:
      "Audited smart contracts build trust among users and investors.",
    icon: sIcon2,
  },
  {
    title: "Regulatory Readiness",
    description:
      "Well-audited contracts help meet compliance and security standards.",
    icon: sIcon3,
  },
  {
    title: "Cost Savings",
    description:
      "Prevent expensive hacks, downtime, and post-launch fixes.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is a smart contract audit?",
    a: "A smart contract audit is a security assessment that identifies vulnerabilities, bugs, and inefficiencies in blockchain smart contracts.",
  },
  {
    q: "Why is a smart contract audit important?",
    a: "Audits help prevent hacks, protect user funds, and ensure reliable contract execution.",
  },
  {
    q: "Which blockchains do you audit?",
    a: "We audit smart contracts on Ethereum, BNB Chain, Polygon, Solana, and other major blockchains.",
  },
  {
    q: "Do you provide audit reports?",
    a: "Yes. We deliver detailed audit reports with findings, severity levels, and remediation guidance.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function SmartContractAudit() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Smart Contract Audit Services"
        pagesub="Secure, reliable & vulnerability-free smart contracts"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Secure Your Code with{" "}
            <span className="gradient-text">Smart Contract Audits</span>
          </>
        }
        subtitle={`Protect your blockchain applications from vulnerabilities, exploits,
and financial risks with professional smart contract auditing services.`}
        buttonText="Request Audit"
        buttonLink="/contact"
        image={img13}
        imageAlt="Smart Contract Audit"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Smart Contract Audits Matter"
        image={img14}
        paragraphs={[
          "Smart contracts control valuable digital assets and business logic on the blockchain. A single vulnerability can lead to irreversible financial losses and reputational damage.",
          "Comprehensive audits help uncover hidden flaws, security risks, and inefficiencies before contracts go live.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Smart Contract Audit Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Risks of Unaudited Smart Contracts"
        image={img15}
        paragraphs={[
          "Unaudited smart contracts are vulnerable to reentrancy attacks, logic bugs, overflow issues, and malicious exploits.",
          "Auditing ensures your contracts function exactly as intended under all conditions.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Smart Contract Audits"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Audit Process"
        subtitle="A structured approach to blockchain security"
        features={[
          {
            icon: sIcon1,
            title: "Comprehensive Code Analysis",
            description:
              "Manual and automated inspection for maximum coverage.",
          },
          {
            icon: sIcon2,
            title: "Vulnerability Classification",
            description:
              "Issues categorized by severity for clear prioritization.",
          },
          {
            icon: sIcon3,
            title: "Best Practice Validation",
            description:
              "Ensure compliance with blockchain security standards.",
          },
          {
            icon: sIcon4,
            title: "Gas & Performance Optimization",
            description:
              "Reduce execution costs without compromising security.",
          },
          {
            icon: sIcon5,
            title: "Detailed Audit Report",
            description:
              "Clear findings, remediation steps, and recommendations.",
          },
          {
            icon: sIcon6,
            title: "Post-Audit Support",
            description:
              "Re-audits and guidance after fixes are applied.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Experienced blockchain security experts",
          "Proven audit methodologies",
          "Transparent and actionable reports",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
